import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives/responsive";

import {
    ContentBlock,
    OneLinkProps,
    OneButtonProps,
    TwoLinksProps
} from "@/components/wpl/content-block/src/content-block";
import {
    StyledBackground,
    BGProps
} from "@/libraries/wpl/foundations/src/styled-backgrounds";

export interface PatternCTAMobileProps {
    headerText: string;
    bodyText?: string;
    eyebrowText?: string;
    footNoteText?: string;
    ctaProps?: OneLinkProps | OneButtonProps | TwoLinksProps;
    className?: string;
    backgroundProperties?: BGProps;
}

const ctaPrimaryStyle = css({
    [media.above.sm]: { padding: "64px 0" },
    "textAlign": "center",
    [media.only.sm]: {
        padding: "48px 0"
    },
    [media.below.sm]: {
        padding: "32px 0"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ".footnote-text": {
        fontSize: "0.875rem",
        margin: "30px auto 0"
    }
});

export const CTAPrimary = ({
    headerText,
    bodyText,
    className,
    eyebrowText,
    footNoteText,
    ctaProps,
    backgroundProperties
}: PatternCTAMobileProps) => {
    return (
        <StyledBackground {...backgroundProperties}>
            <div className={className} css={ctaPrimaryStyle}>
                <div className="primary-cta-content">
                    <ContentBlock
                        isCentered={true}
                        headerText={headerText}
                        headerType="h2"
                        eyebrowText={eyebrowText}
                        bodyText={bodyText}
                        ctaProps={ctaProps}
                    />

                    {footNoteText ? (
                        <p className="footnote-text">{footNoteText}</p>
                    ) : null}
                </div>
            </div>
        </StyledBackground>
    );
};
